<template>
  <div style="height: 100vh;display:flex">
    <div :id="canvasId" class="full" @contextmenu="onContextMenu($event)">
      <svg
        v-if="canvas && canvas.data && canvas.data.grid"
        class="svg-grid"
        width="100%"
        height="100%"
        :style="{ height: canvasHeight }"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="grid"
            width="10"
            height="10"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 10 0 L 0 0 0 10"
              fill="none"
              stroke="#f3f3f3"
              stroke-width="1"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
      <div id="workspace"></div>
    </div>
  </div>
</template>

<script>
import { xyjTopology } from "@/components/topologycomponent/xyjTopology";
import { register as registerFlow } from '@topology/flow-diagram';
import { register as registerActivity } from '@topology/activity-diagram';
import { register as registerClass } from '@topology/class-diagram';
import { register as registerSequence } from '@topology/sequence-diagram';
import { register as registerChart } from '@topology/chart-diagram';
import { Store } from 'le5le-store';
export default {
  name: "DemoWorkFlowClient",
  props:['topologyObject'],
  data() {
    return {
      canvasId:'tcanvas'+Math.random(),
      canvas: null,
      canvasHeight: 0,
      canvasOptions: {},
      selection:{
        pen:'',
        pens:[]
      },
      data: {
        id: "",
        version: "",
        name: "空白文件",
        desc: "",
        image: "",
        userId: "",
        class: "",
        component: false,
        shared: false,
      },
    };
  },
  created(){
    this.canvasOptions.on = this.onMessage;
    setTimeout(() => {
      this.canvas = new xyjTopology(this.canvasId, this.canvasOptions);
      this.onOpen()
      this.canvasHeight = this.canvas.canvas.height;
      this.selection = null;
      // let obj = {"pens":[{"type":0,"rect":{"x":199,"y":249,"width":300,"height":200,"center":{"x":349,"y":349},"ex":499,"ey":449},"lineWidth":1,"rotate":0,"offsetRotate":0,"globalAlpha":1,"dash":0,"strokeStyle":"#222","fillStyle":"","font":{"color":"#222","fontFamily":"\"Hiragino Sans GB\", \"Microsoft YaHei\", \"Helvetica Neue\", Helvetica, Arial","fontSize":12,"lineHeight":1.5,"fontStyle":"normal","fontWeight":"normal","textAlign":"center","textBaseline":"middle"},"animateCycleIndex":0,"events":[],"eventFns":["link","doAnimate","doFn","doWindowFn"],"id":"b970a2a","name":"echarts","tags":[],"lineDashOffset":0,"text":"折线图","textOffsetX":0,"textOffsetY":0,"animateType":"","visible":true,"data":{"echarts":{"option":{"series":[{"data":[820,932,901,934,1290,1330,1320],"type":"line"}],"xAxis":{"data":["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],"type":"category"},"yAxis":{"type":"value"}}}},"zRotate":0,"anchors":[{"x":199,"y":349,"direction":4},{"x":349,"y":249,"direction":1},{"x":499,"y":349,"direction":2},{"x":349,"y":449,"direction":3}],"rotatedAnchors":[{"x":199,"y":349,"direction":4},{"x":349,"y":249,"direction":1},{"x":499,"y":349,"direction":2},{"x":349,"y":449,"direction":3}],"animateDuration":0,"animateFrames":[],"borderRadius":0,"iconSize":null,"imageAlign":"center","bkType":0,"gradientAngle":0,"gradientRadius":0.01,"paddingTop":0,"paddingBottom":0,"paddingLeft":0,"paddingRight":0,"elementId":"f52579c","elementLoaded":true,"paddingLeftNum":0,"paddingRightNum":0,"paddingTopNum":0,"paddingBottomNum":0,"textRect":{"x":199,"y":399,"width":300,"height":50,"center":{"x":349,"y":424},"ex":499,"ey":449},"fullTextRect":{"x":199,"y":249,"width":300,"height":200,"center":{"x":349,"y":349},"ex":499,"ey":449},"iconRect":{"x":199,"y":249,"width":300,"height":150,"center":{"x":349,"y":324},"ex":499,"ey":399},"fullIconRect":{"x":199,"y":249,"width":300,"height":200,"center":{"x":349,"y":349},"ex":499,"ey":449},"elementRendered":true,"TID":"7cc54274"}],"lineName":"curve","fromArrow":"","toArrow":"triangleSolid","scale":1,"locked":1,"mqttOptions":{"clientId":"21b80ff1"},"data":""}
      console.log(this.topologyObject)
      if(this.topologyObject && this.$tu.isObj(this.topologyObject)){
        this.canvas.open(this.topologyObject)
      }else if(this.topologyObject){
        this.canvas.open(JSON.parse(this.topologyObject).data)
      }
      this.canvas.fitView();
      this.canvas.lock(1);
      this.canvas.render();
    });
    registerFlow();
    registerActivity();
    registerClass();
    registerSequence();
    registerChart();
  },
  mounted(){
    setTimeout(() => {
      this.selection = null;
    });
    // this.onOpenFile();
    // this.open()
  },
  methods: {
    async onOpen() {
      if (!this.$route.query.id) {
        return
      }
      const data = await this.$axios.$get(
        '/api/topology/' + this.$route.query.id
      )
      if (data && data.id) {
        this.canvas.open(data.data)
      }
    },
    onMessage(event, data) {
      switch (event) {
        case 'node':
        case 'addNode':
        case 'line':
        case 'addLine':
          this.selection = {
            pen: data
          };
          this.locked = data.locked;
          this.propkey++
          break;
        case 'multi':
          this.locked = true;
          if (data && data.length) {
            this.selection = {
              pens: data
            };
            for (const item of data) {
              if (!item.locked) {
                this.locked = false;
                break;
              }
            }
          }
          break;
        case 'space':
          this.selection = null;
          break;
        case 'moveOut':
          // this.workspace.nativeElement.scrollLeft += 10;
          // this.workspace.nativeElement.scrollTop += 10;
          break;
        case 'resize':
          if (data) {
            this.canvasHeight = data.height;
          }

          if (!this.mouseMoving) {
            this.mouseMoving = true;
            // this.workspace.nativeElement.scrollLeft = this.workspace.nativeElement.scrollWidth;
            // this.workspace.nativeElement.scrollTop = this.workspace.nativeElement.scrollHeight;
            setTimeout(() => {
              this.mouseMoving = false;
            }, 2000);
          }

          break;
        case 'scale':
          Store.set('scale', data);
          break;
        case 'locked':
          Store.set('locked', data);
          break;
      }
      console.log('onMessage:', event, data);
    },
    onContextMenu(event) {
      event.preventDefault();
      event.stopPropagation();

      if (event.clientY + 360 < document.body.clientHeight) {
        this.contextmenu = {
          left: event.clientX + "px",
          top: event.clientY + "px",
        };
      } else {
        this.contextmenu = {
          left: event.clientX + "px",
          bottom: "5px",
        };
      }
    },
    // 打开文件
    onOpenFile() {
      const input = document.createElement('input');
      input.type = 'file';
      input.onchange = event => {
        const elem = event.target;
        if (elem.files && elem.files[0]) {
          if (elem.files[0].name.indexOf('.json') > 0) {
            this.openJson(elem.files[0]);
          } else {
            this.openZip(elem.files[0]);
          }

        }
      };
      input.click();
    },
    // 打开json文件
    openJson(file) {
      const name = file.name.replace('.json', '');
      this.data.name = name;
      Store.set('file', this.data);
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result + '';
        try {
          const data = JSON.parse(text);
          if (data && data.lineName) {
            Store.set('lineName', data.lineName);
            Store.set('fromArrowType', data.fromArrowType);
            Store.set('toArrowType', data.toArrowType);
            this.data = {
              id: '',
              version: '',
              data,
              name: name,
              desc: '',
              image: '',
              userId: '',
              class: '',
              component: false,
              shared: false
            };
            this.canvas.open(data);
          }
        } catch (e) {
          return false;
        }
      };
      reader.readAsText(file);
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../components/topologycomponent/variables";
@import "../../components/topologycomponent/le5levariables";
.full {
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-x: auto;

  & > div {
    min-height: 100%;
  }

  svg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
.tools {
  flex-shrink: 0;
  width: 180px;
  border-right: 1px solid $color-border;
  background-color: #f8f8fa;

  .title {
    padding: 5px 10px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    &:first-child {
      border-top: none;
    }
  }

  .buttons {
    padding: 10px 0;
    a {
      display: inline-block;
      color: $color;
      line-height: 1;
      width: 40px;
      height: 40px;
      text-align: center;
      text-decoration: none !important;

      .iconfont {
        font-size: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topologycomponent/previewTopology.vue